import React from 'react';

function Process() {
  return (
    <section id="process-section" className="section-padding bg-light">
      <div className="container">
        <h2>The Savage Agent Enablement Process</h2>
        <div className="process-timeline">
          
          {/* Step 1 */}
          <div className="process-step">
            <div className="step-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              </svg>
            </div>
            <div className="step-content">
              <h4>1. Cognitive Discovery</h4>
              <p>We audit your manual workflows, identify high-ROI agent tasks, and scope strict execution tool boundaries.</p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="process-step">
            <div className="step-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
              </svg>
            </div>
            <div className="step-content">
              <h4>2. Architecture & Prompting</h4>
              <p>We design custom reasoning loops (ReAct/CoT), code system parameters, and build mock-tool testing environments.</p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="process-step">
            <div className="step-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <path d="M21 12H3" />
                <path d="M12 3v18" />
              </svg>
            </div>
            <div className="step-content">
              <h4>3. Secure Deployment</h4>
              <p>We anchor agent instances in GCP/OCI secure containers, integrate API authorizations, and set human approval gates.</p>
            </div>
          </div>

          {/* Step 4 */}
          <div className="process-step">
            <div className="step-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
              </svg>
            </div>
            <div className="step-content">
              <h4>4. Trajectory Optimization</h4>
              <p>We audit agent action logs, optimize token-spend ratios, adjust planning trees, and fine-tune models iteratively.</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Process;
